import React, { useState, useEffect } from "react";
import useApiServices from "../../utils/useApiServices";
import swal from "sweetalert";
import { useLocation } from "react-router-dom";
import { Button, Card, Modal } from "react-bootstrap";
import { Row } from "react-bootstrap";
import {
  FETCH_ALL_MERCHANT_VALIDATIONS,
  FETCH_ALL_MERCHANT_PAYOUT_ROUTING_ONBORDING,
  GET_VIRTUAL_ACCOUNT_DATA,
  POST_MERCHANT_SAVE,
  // HANDLE_SEARCH_LIMIT, // Not used, can be removed if not needed elsewhere
  GET_PREV_MAPPED_DETAILS_PAYOUT,
  HANDLE_SEARCH_LIMIT_PAYOUT,
  FETCH_ONBOARD_MERCHANT_DETAILS,
} from "../../utils/constant";
import {
  stopCharacterInput,
  stopSpecialCharacterInput,
} from "../../utils/helper";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const PayoutRouting = ({ show, onHide, refresh, setRefresh, FetchData }) => {
  const [merchantData, setMerchantData] = useState([]);
  const [selectedMerchant, setSelectedMerchant] = useState("");
  const [selectedMid, setSelectedMid] = useState("");
  const [callbackUrlValue, setCallbackUrlValue] = useState("");
  const [route, setRoute] = useState("");
  const [companyData, setCompanyData] = useState([]);
  const [companyDataFiltered, setCompanyDataFiltered] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [companyMid, setCompanyMid] = useState(""); // This state seems unused now if mappedMid is directly from selectedData elem
  const [transferType, setTransferType] = useState("IMPS");
  const [returnUrl, setReturnUrl] = useState("");
  const [callbackUrl, setCallbackUrl] = useState("");
  const [routingPattern, setRoutingPattern] = useState("");
  const [mappedMerchant, setMappedMerchant] = useState([]); // This state is primarily for display of ALL rows
  // mappedMerchant will hold objects like:
  // { mid: '...', masterCompanyName: '...', payoutRemainigLimit: ..., payoutLimit: '...', prority: ..., isNew: true/false }

  const [priority, setPriority] = useState([]); // This state still seems redundant, consider removing if not explicitly used
  const [keyName, setKeyName] = useState("");
  const [SidData, setSidData] = useState([]); // This state seems unused in the current context for input values, can be removed
  const [selectedData, setSelectedData] = useState([]);
  // selectedData will hold objects like:
  // { mid: '...', maxTxnAmtInputVal: '...', prority: ..., isNew: true/false }

  const [sidDetailsData, setSidDetailsData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState({
    sid: "",
    txnAmt: "",
    merchantSelect: "",
  }); // This state seems unused, can be removed

  const { apiCallFnforGet, apiCallFnforPost } = useApiServices();

  const getAllMerchantForApiTest = async () => {
    let res = await apiCallFnforGet(FETCH_ALL_MERCHANT_VALIDATIONS);
    setMerchantData(res.data);
  };

  const getAllMerchantForOnBoardingRoutingPayout = async () => {
    let res = await apiCallFnforGet(
      FETCH_ALL_MERCHANT_PAYOUT_ROUTING_ONBORDING
    );
    setMerchantData(res.data);
  };

  useEffect(() => {
    getAllMerchantForApiTest();
  }, [refresh]);

  const getVirtualAccountData = async (type) => {
    await apiCallFnforGet(GET_VIRTUAL_ACCOUNT_DATA + type)
      .then((response) => {
        if (response.statusCode === 200) {
          setCompanyData(response.data);
          setCompanyDataFiltered(response.data);
        } else {
          setCompanyData([]);
          setCompanyDataFiltered([]); // Clear filtered data too
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setCompanyData([]);
        setCompanyDataFiltered([]);
      });
  };

  useEffect(() => {
    if (route === "") {
      setCompanyDataFiltered(companyData);
    } else {
      setCompanyDataFiltered(
        companyData.filter((item) => {
          return item?.masterAliusId?.split("_")[0].toUpperCase() === route;
        })
      );
    }
    // console.log(
    //   companyData.filter((item) =>
    //     item?.masterAliusId?.includes(route.toLowerCase())
    //   )
    // );
  }, [route, companyData]); // Added companyData to dependency array

  useEffect(() => {
    getVirtualAccountData("IMPS");
  }, []);

  const getPrevMappedDetails = async (mid) => {
    await apiCallFnforGet(GET_PREV_MAPPED_DETAILS_PAYOUT + mid)
      .then((response) => {
        if (response.statusCode === 200) {
          const fetchedMappedMerchants = response?.data.map((item, index) => ({
            ...item,
            idForUse: index + 1,
            payoutLimit: item.payoutLimit || "", // Ensure payoutLimit is a string for input value
            prority: item.prority || index + 1, // Default priority if not available
            isNew: false, // Mark as existing
          }));
          setMappedMerchant(fetchedMappedMerchants);

          // Populate selectedData with the fetched existing mappings, also marked as existing
          setSelectedData(
            fetchedMappedMerchants.map((item, i) => ({
              mid: item.mid,
              maxTxnAmtInputVal: item.payoutLimit,
              prority: item.prority,
              isNew: false, // Mark as existing
            }))
          );
          setRoutingPattern(response?.data[0]?.routingType || "");
        } else {
          setMappedMerchant([]);
          setSelectedData([]); // Clear selectedData if no previous details
          setRoutingPattern("");
        }
      })
      .catch((error) => {
        console.error("Error fetching previous mapped details:", error);
        setMappedMerchant([]);
        setSelectedData([]); // Clear selectedData on error too
      });
  };

  const handleMerchantChange = async (event) => {
    try {
      setMappedMerchant([]);
      const selectedMerchant = event?.target?.value;
      const selectedMerchantData = merchantData?.find(
        (merchant) => merchant?.mid === selectedMerchant
      );

      if (selectedMerchantData) {
        const { mid } = selectedMerchantData;
        setSelectedMerchant(selectedMerchant);
        setSelectedMid(mid);

        let payoutRes = await apiCallFnforGet(
          FETCH_ONBOARD_MERCHANT_DETAILS + mid
        );

        if (payoutRes.statusCode === 200) {
          const payoutActiveFor = payoutRes.data?.payoutActiveFor || "";
          const payoutType = String(payoutActiveFor)?.toLowerCase();
          const payoutCallBackUrl = payoutRes.data?.payoutCallbackUrl || "";
          setCallbackUrl(payoutActiveFor);
          if (payoutType === "api" || payoutType === "both") {
            setCallbackUrlValue(payoutCallBackUrl);
          } else {
            setCallbackUrlValue("");
          }

          getPrevMappedDetails(mid);
        } else {
          setCallbackUrl("");
          setCallbackUrlValue("");
        }
      } else {
        setSelectedMerchant("");
        setSelectedMid("");
        setCallbackUrl("");
        setCallbackUrlValue("");
        setMappedMerchant([]);
        setSelectedData([]);
        setRoutingPattern("");
      }
    } catch (error) {
      setSelectedMerchant("");
      setSelectedMid("");
      setCallbackUrl("");
      setCallbackUrlValue("");
      setMappedMerchant([]);
      setSelectedData([]);
      setRoutingPattern("");
    }
  };

  const handleSavePayoutWithdrawal = async () => {
    if (!selectedMerchant) {
      swal("Error", "Please select a Merchant!", "error");
      return;
    }
    if (!callbackUrl) {
      swal(
        "Error",
        "Payout active for is not available for this merchant, so payout routing cannot be created at this time.",
        "error"
      );
      return;
    }
    if (!route) {
      swal("Error", "Please select Route With!", "error");
      return;
    }
    if (!routingPattern) {
      swal("Error", "Please select Routing Pattern!", "error");
      return;
    }
    if (mappedMerchant.length === 0) {
      swal("Error", "Please add at least one Virtual Account!", "error");
      return;
    }
    if (callbackUrl === "API" && !callbackUrlValue) {
      swal("Error", "Callback URL is required!", "error");
      return;
    }

    // Filter to include only NEWLY ADDED items AND ensure they have a txn amount
    const newPayloadItems = selectedData.filter(
      (elem) =>
        elem.isNew &&
        elem.maxTxnAmtInputVal !== undefined &&
        elem.maxTxnAmtInputVal !== ""
    );

    const payload = newPayloadItems?.map((elem) => ({
      masterLimit: elem?.maxTxnAmtInputVal,
      mid: selectedMid,
      mappedMid: elem?.mid,
      prority: elem?.prority,
      requestRoute: route,
      routingType: routingPattern,
      transferType: transferType,
      callBackUrl:
        callbackUrl === "API" || callbackUrl === "BOTH" ? callbackUrlValue : "",
      usedFor: callbackUrl,
    }));

    console.log("Final Payload for Submission (New Rows Only):", payload);

    if (!payload || payload.length === 0) {
      swal(
        "Error",
        "Please enter Maximum Txn Amount for newly added Virtual Account!",
        "error"
      );
      return;
    }

    await apiCallFnforPost(POST_MERCHANT_SAVE, payload)
      .then((response) => {
        if (response.statusCode === 200) {
          swal("Success", "Payout saved successfully!", "success");
          handleClose(); // Use handleClose to reset all states
        } else {
          swal("Error", response.message, "error");
        }
      })
      .catch((error) => {
        console.error("Error saving payout:", error);
        swal("Error", "An error occurred while saving the payout.", "error");
      });
  };

  const handleSelectChange = (event) => {
    setCallbackUrl(event?.target?.value);
  };

  const handleRouteChange = (event) => {
    setRoute(event?.target?.value);
  };

  const handleCompanyChange = (event) => {
    if (!selectedMerchant) {
      swal("Error", "Please select a Merchant first.", "error");
      setSelectedCompany(""); // Reset the dropdown
      return;
    }

    if (!callbackUrl) {
      swal(
        "Error",
        "Payout active for is not available for this merchant, so payout routing cannot be created at this time.",
        "error"
      );
      // setSelectedCompany(""); // Reset the dropdown
      return;
    }

    const selectedCompanyValue = event.target.value;
    setSelectedCompany(selectedCompanyValue);

    const selectedCompanyData = companyDataFiltered.find(
      (company) => company.companyName + company.mid === selectedCompanyValue
    );

    if (selectedCompanyData) {
      const { mid, companyName } = selectedCompanyData;

      // Add the new virtual account to mappedMerchant (for display), marked as new
      setMappedMerchant((prevMappedMerchants) => [
        ...prevMappedMerchants,
        {
          idForUse: prevMappedMerchants.length + 1,
          mid: mid,
          masterCompanyName: companyName,
          payoutRemainigLimit: 0,
          payoutLimit: "",
          prority: prevMappedMerchants.length + 1,
          isNew: true,
        },
      ]);

      // Add the new virtual account to selectedData (for payload), marked as new
      setSelectedData((prevSelectedData) => [
        ...prevSelectedData,
        {
          mid: mid,
          maxTxnAmtInputVal: "", // Initialize input value for new entry
          prority: prevSelectedData.length + 1, // Assign priority based on current selectedData length
          isNew: true, // Mark as NEW
        },
      ]);
    }
  };

  const handleClose = () => {
    onHide();
    setCallbackUrlValue("");
    setSelectedCompany("");
    setTransferType("IMPS"); // Reset to default
    setCallbackUrl("");
    setSelectedMerchant("");
    setRoute("");
    setRefresh(!refresh);
    setSelectedData([]); // Clear selectedData
    setMappedMerchant([]); // Clear mappedMerchant
    setRoutingPattern("");
  };

  const getKeyName = (e) => {
    setKeyName(e.key);
  };

  const handelSearchLimit = async (e, masterID) => {
    await apiCallFnforGet(HANDLE_SEARCH_LIMIT_PAYOUT + masterID)
      .then((response) => {
        console.log(response);

        if (response.statusCode === 200) {
          const searchRes = response.data.map((item, i) => ({
            id: i,
            mid: item.mid,
            companyName: item.companyName,
            sid: item.sid,
            sidLimit: item.sidLimit,
          }));

          setSidDetailsData(searchRes);
        } else {
          setSidDetailsData([]);
          console.error("Error fetching data:", response.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

    setIsModalOpen(true);
  };

  const handelTxnInput = (e, index, currentPrority) => {
    if (stopSpecialCharacterInput(keyName) || stopCharacterInput(keyName)) {
      return;
    }

    const inputValue = e.target.value;

    // Update mappedMerchant (for display)
    setMappedMerchant((prevMapped) =>
      prevMapped.map((elem, i) =>
        String(index) === String(i)
          ? { ...elem, payoutLimit: inputValue }
          : elem
      )
    );

    // Update selectedData (for payload submission)
    setSelectedData((prevSelected) => {
      if (index !== -1) {
        // Update existing entry
        const updated = [...prevSelected];
        updated[index] = {
          ...updated[index],
          maxTxnAmtInputVal: inputValue,
          prority: currentPrority, // Ensure priority is carried over
        };
        return updated;
      } else {
        // This case should ideally not happen if handleCompanyChange works correctly,
        // but it's a fallback to add if an item somehow wasn't in selectedData.

        // If adding as a fallback, assume it's a new entry if not found
        return [
          ...prevSelected,
          {
            index,
            maxTxnAmtInputVal: inputValue,
            prority: currentPrority,
            isNew: true, // Mark as NEW if added here as a fallback
          },
        ];
      }
    });
  };

  const HandleDelete = (id) => {
    const filteredData = mappedMerchant?.filter((item) => item.idForUse !== id);
    setMappedMerchant(filteredData);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCancelAction = () => {
    setSelectedData([]);
    setMappedMerchant([]);
    setRoutingPattern("");
    setCallbackUrlValue("");
    setSelectedCompany("");
    setTransferType("IMPS");
    setCallbackUrl("");
    setSelectedMerchant("");
    setRoute("");
  };

  const sidDetailsColumn = [
    { headerName: "Merchant ID", field: "mid", minWidth: 150 },
    { headerName: "Merchant Name", field: "companyName", minWidth: 200 },
    { headerName: "SID", field: "sid", minWidth: 200 },
    { headerName: "SID Limit", field: "sidLimit", minWidth: 150 },
  ];

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="modal-xxl modal-dialog-centered"
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fs-4 fw-bold">Routing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <div className="row d-flex justify-content-center">
              <div className="col-lg-3 mb-2 ">
                <div className="mb-3">
                  <label className="mb-1 text-dark fs-4">
                    Select A Merchant
                  </label>
                  <select
                    id="companyDropdown"
                    className="form-control"
                    onChange={handleMerchantChange}
                    value={selectedMerchant}
                  >
                    <option value="">Select a Merchant</option>
                    {merchantData?.map((merchant) => (
                      <option key={merchant?.mid} value={merchant?.mid}>
                        {merchant?.mid} :- {merchant?.merchantName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-lg-3 mb-3">
                <label className="mb-1 text-dark fs-5">Payout Active For</label>
                <input
                  type="text"
                  className="form-control"
                  value={callbackUrl}
                  disabled
                  readOnly
                />
              </div>
              <div className="col-lg-3 mb-2">
                <div className="mb-3">
                  <label className="mb-1 text-dark fs-5">Route With</label>
                  <select
                    id="routingPatternSelect"
                    className="form-control"
                    value={route}
                    onChange={handleRouteChange}
                    name="routingPattern"
                  >
                    <option value="">Select</option>
                    <option value="DECENTRO">DECENTRO</option>
                    <option value="FINZEN">FINZEN</option>
                    <option value="BRANCHX">BRANCHX</option>
                    <option value="PAYWINGS">PAYWINGS</option>
                    <option value="VIMO">VIMO</option>
                    <option value="SURYODAY">SURYODAY</option>
                  </select>
                </div>
              </div>
              <div className="col-lg-3 mb-2">
                <div className="mb-3">
                  <label className="mb-1 text-dark fs-4">Routing Pattern</label>
                  <select
                    id=""
                    className="form-control"
                    onChange={(e) => setRoutingPattern(e.target.value)}
                    value={routingPattern}
                    name="routingPattern"
                  >
                    <option value="">Select a Pattern</option>
                    <option value="RR">Round Robin</option>
                    <option value="SQ">Sequential</option>
                  </select>
                </div>
              </div>
              {/* Dynamic Mapped Virtual Accounts */}
              <div className="d-flex flex-column align-items-center w-100">
                {mappedMerchant?.map((elem, index) => (
                  <div
                    key={elem.idForUse} // Use mid as key for uniqueness
                    className="w-100 d-flex mt-3 py-2 border-bottom align-items-center"
                  >
                    <div className="form-group d-flex flex-column col-sm-12 col-md-4 mt-2">
                      <div className="">
                        <strong>{elem.masterCompanyName}</strong> <br />
                        <small>{elem.mid}</small>
                      </div>
                      <span className="text-danger mt-1">
                        Remaining Limit : {`${elem.payoutRemainigLimit ?? 0}`}
                      </span>
                    </div>
                    <div className="form-group col-sm-12 col-md-3 mt-2 ">
                      <label>Enter Maximum Txn Amount</label>
                      <input
                        type="text"
                        className="form-control"
                        id={`txnAmt-${elem.mid}`} // Unique ID
                        name="txnAmt"
                        placeholder="Enter Maximum Txn Amount"
                        value={elem.payoutLimit || ""} // Use payoutLimit from mappedMerchant for display
                        onKeyDown={getKeyName}
                        onChange={(e) =>
                          elem?.isNew
                            ? handelTxnInput(e, index, elem.prority)
                            : console.log("lkjhgf")
                        }
                      />
                    </div>
                    <div className="col-sm-12 col-md-2 mx-3 d-flex align-items-center ">
                      <button
                        className="badge bg-primary text-white ms-2"
                        size="sm"
                        onClick={(e) => handelSearchLimit(e, elem.mid)}
                      >
                        View Mapped MID's
                      </button>
                    </div>
                    {routingPattern === "RR" ? null : (
                      <>
                        <div className="col-sm-12 col-md-2 my-2 ">
                          <label>Priority</label>
                          <input
                            type="text"
                            value={elem.prority}
                            readOnly
                            className="form-control"
                          />
                        </div>
                      </>
                    )}
                    {!elem.isNew ? null : (
                      <div className="col-sm-12 col-md-2 my-2 ">
                        <button
                          onClick={() => HandleDelete(elem.idForUse)}
                          className="btn btn-sm btn-danger mx-2"
                        >
                          Delete
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <Row className="d-flex justify-content-center">
                <div className="w-100 d-flex justify-content-evenly align-items-center gap-3 p-3 py-2">
                  <div className="checkbox-wrapper-27">
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        style={{ border: "1px solid grey", scale: "1" }}
                        className="form-check-input"
                        name="bankDetails"
                        checked={transferType === "IMPS"}
                        onChange={() => {
                          setTransferType("IMPS");
                          getVirtualAccountData("IMPS");
                        }}
                      />
                      <span className="checkbox__icon"> </span>
                      IMPS
                    </label>
                  </div>
                  <div className="checkbox-wrapper-27">
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        style={{ border: "1px solid grey", scale: "1" }}
                        className="form-check-input"
                        name="bankDetails"
                        checked={transferType === "UPI"}
                        onChange={() => {
                          setTransferType("UPI");
                          getVirtualAccountData("UPI");
                        }}
                      />
                      <span className="checkbox__icon"> </span>
                      UPI
                    </label>
                  </div>
                </div>
              </Row>
              <div className="row d-flex justify-content-center">
                <div className="col-lg-12 mb-2">
                  <div className="mb-3">
                    <label className="mb-1 text-dark fs-5">
                      Select Virtual Account
                    </label>
                    <select
                      className="form-control"
                      id="holdAmount"
                      value={selectedCompany}
                      onChange={handleCompanyChange}
                    >
                      <option value="">Select Virtual Account</option>
                      {companyDataFiltered?.map((company) => (
                        <option
                          key={company.mid}
                          value={company.companyName + company.mid}
                        >
                          {company.mid + " :- " + company?.companyName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="row d-flex justify-content-center">
                <div className="col-lg-6 mb-2">
                  <div className="mb-3">
                    {callbackUrl === "API" || callbackUrl === "BOTH" ? (
                      <div>
                        <label className="mb-1 text-dark fs-5">
                          Callback URL
                        </label>
                        <input
                          type="text"
                          id="callbackUrlValue"
                          name="callbackUrlValue"
                          placeholder="Enter Callback URL"
                          className="form-control"
                          value={callbackUrlValue}
                          onChange={(e) => setCallbackUrlValue(e.target.value)}
                          disabled
                          readOnly
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-center mt-4">
                <button
                  className="badge badge-rounded badge-primary mx-2 px-3 py-3"
                  onClick={handleSavePayoutWithdrawal}
                >
                  Submit
                </button>
                <button
                  className="badge badge-rounded badge-info mx-2 px-3 py-3"
                  onClick={handleCancelAction}
                >
                  Cancel
                </button>
              </div>
            </div>
            <Modal show={isModalOpen} onHide={handleCloseModal} size="lg">
              <Modal.Header closeButton>
                <Modal.Title className="fw-bold">SID Details:</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Card.Body>
                  <div className="merchant-report-view">
                    <div className="report-table-view">
                      <div className="containerflag ">
                        <div className="row mt-4 ">
                          <DataGrid
                            rows={sidDetailsData}
                            columns={sidDetailsColumn}
                            slots={{
                              toolbar: GridToolbar,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Modal.Body>
            </Modal>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PayoutRouting;
